// src/features/presence/usage-section.tsx
import { KpiTile } from "@/components/iris";
import { Kicker } from "@/components/iris/kicker";
import { formatCount } from "@/lib/format-count";
import type { Env, PresenceUsage } from "@/lib/types";
import { CalendarDays, CalendarRange, Users } from "lucide-react";

interface UsageSectionProps {
  data: PresenceUsage;
  env: Env;
}

/** IR-1148 §2 — active-user reach: DAU / WAU / MAU for the selected env. */
export function UsageSection({ data, env }: UsageSectionProps) {
  const kpiEnv = env === "dev" ? "dev" : "prod";
  return (
    <>
      <Kicker style={{ marginTop: 32, marginBottom: 12 }}>Active Users</Kicker>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
        <KpiTile
          label="Daily Active (DAU)"
          value={formatCount(data.dau)}
          icon={Users}
          tone="cyan"
          env={kpiEnv}
        />
        <KpiTile
          label="Weekly Active (WAU)"
          value={formatCount(data.wau)}
          icon={CalendarDays}
          tone="purple"
          env={kpiEnv}
        />
        <KpiTile
          label="Monthly Active (MAU)"
          value={formatCount(data.mau)}
          icon={CalendarRange}
          tone="magenta"
          env={kpiEnv}
        />
      </div>
    </>
  );
}
